angular.module('dpw.services')
    .filter('postLink', function () {
        return function (id, forceEmpty) {
            if (forceEmpty || !id) {
                return '';
            }
            return 'blog-post.html?id=' + id;
        }
    });